import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";
import { ClientSettings } from "../types/Client/ClientSettings";

export interface ClientConfigRecord {
  dlClientID: string;
  clientConfig: ClientSettings;
}

@Injectable({
  providedIn: "root",
})
export class ClientConfigRepository extends ArrayStorageRepository<ClientConfigRecord> {
  constructor(storage: Storage) {
    super(storage, "clientConfigs", "dlClientID");
  }

  public setClientConfig(
    dlClientID: string,
    clientConfig: ClientSettings,
  ): Promise<ClientConfigRecord> {
    return this.saveRecord("dlClientID", { dlClientID, clientConfig });
  }

  public async getClientConfig(
    dlClientID: string,
  ): Promise<ClientSettings | undefined> {
    const record = await this.getById(dlClientID);
    return record?.clientConfig;
  }
}
